import { useDispatch, useSelector } from "react-redux";
import { setThemeMode } from "@/store/slices/ui.slice";
import { selectThemeMode } from "@/store/selectors/ui.selectors";

export function useTheme(): {
  themeMode: "light" | "dark" | "auto";
  toggleTheme: () => void;
} {
  const dispatch = useDispatch();
  const themeMode = useSelector(selectThemeMode);

  const toggleTheme = (): void => {
    const newMode = themeMode === "light" ? "dark" : "light";
    dispatch(setThemeMode(newMode));
  };

  return { themeMode, toggleTheme };
}
